export enum EBottomPanelComponentName {
  OrganizationMenu = 'OrganizationMenu',
  LanguageSelectMenu = 'LanguageSelectMenu',
  LogoutMenu = 'LogoutMenu',
  OrganizationSelectMenu = 'OrganizationSelectMenu',
  ImportMedia = 'ImportMedia',
  AnalyticsFilter = 'AnalyticsFilter',
}
